module.exports = __webpack_public_path__ + "img/btn_online@2x.16242ddf.png";